export const AUDIO_FREE_TRIAL_END = new Date("2026-07-31T00:00:00.000Z");
export const isAudioFreeTrial = new Date() < AUDIO_FREE_TRIAL_END;
